<template>
  <div class="d-flex justify-center align-center" style="height: 100vh;">
    <v-progress-circular indeterminate color="primary" class="mr-3" />
    <span>Выходим...</span>
  </div>
</template>

<script>
export default {
  name: 'Signout',
  mounted() {
    this.signOut();
  },
  methods: {
    async signOut() {
      try {
        // Store action handles API call and state cleanup
        await this.$store.dispatch('logout');
      } catch (error) {
        console.error('Error during sign out:', error);
      }
      // Always redirect to signin page
      this.$router.push('/signin');
    }
  }
};
</script>
